import { useAtomValue, useSetAtom } from 'jotai';
import { useKpiWorkLogFormContext } from '../../hooks';
import { shouldShowPobInput, selectedLogTemplateType } from '../../state';
import { KpiPanelSection } from './KpiPanelSection';
import { AttachmentsSection } from './AttachmentsSection';
import { JobPhaseSection } from './JobPhaseSection';
import { KPI_CONFIG_SECTION_KEY, KPI_POB_FIELD_KEY } from '../../constants';
import { useEffect } from 'react';
import { LogTemplateType } from '@/__generated__/graphql';

export const KpiLoggingTab = () => {
  const { formik, isSubmitting, template, sections, workpackLogs, logsLoading } =
    useKpiWorkLogFormContext();

  const setShouldShowPobInput = useSetAtom(shouldShowPobInput);
  const logType = useAtomValue(selectedLogTemplateType);
  const isWorklog = logType === LogTemplateType.WorklogTemplate;

  // Only show the POB input field if there are 'hour' fields
  // and a field named 'pob' exists in the template
  useEffect(() => {
    setShouldShowPobInput(
      Boolean(
        sections?.some((section) => section.key === KPI_CONFIG_SECTION_KEY) &&
          template?.fields?.some((field) => field.key === KPI_POB_FIELD_KEY)
      )
    );
  }, [sections, setShouldShowPobInput, template?.fields]);

  if (!sections || !template) return <></>;

  return (
    <>
      {sections
        .filter((section) => section.displayInLogging)
        .map((section) => (
          <KpiPanelSection
            key={section.id}
            section={section}
            fields={template.fields}
            workpackLogs={workpackLogs}
            logsLoading={logsLoading}
            formik={formik}
            isSubmitting={isSubmitting}
          />
        ))}

      <AttachmentsSection />
      {isWorklog && <JobPhaseSection />}
    </>
  );
};
